import { Checkbox as SharedCheckbox } from "@sportal/cdk";
import "./Checkbox.scss";

export const Checkbox = SharedCheckbox;
